function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { anchorCdnUrl } from "../../constants";
import PaymentMethodPanel from "./PaymentMethodPanel";
import { jsx as _jsx } from "react/jsx-runtime";
const brandLogos = {
  jcb: 'jcb.svg',
  amex: 'amex.svg',
  visa: 'visa.svg',
  mastercard: 'mastercard.svg',
  discover: 'discover.svg',
  diners: 'diners-club.svg',
  unionpay: 'unionpay.svg'
};
const defaultCardLogo = 'default-card.svg';
export default function CreditCardPanel(props) {
  const {
    creditCard
  } = props;
  const {
    last4,
    creditCard: {
      brand,
      expiry
    }
  } = creditCard;
  return /*#__PURE__*/_jsx(PaymentMethodPanel, _objectSpread(_objectSpread({}, props), {}, {
    title: "Credit Card",
    description: "****".concat(last4).concat(expiry ? " (Expires ".concat(expiry.month, "/").concat(expiry.year, ")") : ''),
    logo: /*#__PURE__*/_jsx("img", {
      alt: "credit card logo",
      "data-testid": "credit-card-logo",
      src: "".concat(anchorCdnUrl, "/images/credit-cards/").concat(brandLogos[brand] || defaultCardLogo)
    })
  }));
}